import {customElement, property} from 'lit/decorators.js';
import {SbkAccordion} from "@/components/accordion/accordion.ts";
import {filterToggleStyles} from "@/components/filter-toggle/filter-toggle.styles.ts";

/**
 * @slot default - Inhalt
 */
@customElement('sbk-filter-toggle')
export class SbkFilterToggle extends SbkAccordion {

    @property({attribute: 'expanded', type: Boolean})
    _expanded = false

    static get styles() {
        return filterToggleStyles;
    }
}
